import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { PrimaryButton, Table } from 'appSrc/components/UI';
import style from './styles/style.module.css';

class FieldDiffsTable extends PureComponent {
    render() {
        const { dataDifferences, updatingFieldDiffs, confirmUpdateFieldDiffs } = this.props;

        let fieldDiffActions = null;
        if ( updatingFieldDiffs ) {
            fieldDiffActions = (
                <span style={ { marginLeft: '15px' } }>(Updating fields in database...)</span>
            );
        } else if ( dataDifferences.length !== 0 ) {
            fieldDiffActions = (
                <PrimaryButton label='Update Database' onClick={ confirmUpdateFieldDiffs }
                style={ { marginLeft: '15px' } } />
            );
        }

        return (
            <div>
                <div className={ style.dataHeader }>Field Differences</div>
                <Table>
                    <Table.Head>
                        <Table.Row>
                            <Table.Cell>AFFILIATE TYPE</Table.Cell>
                            <Table.Cell>ADVERTISER ID</Table.Cell>
                            <Table.Cell>
                                ADVERTISER NAME { fieldDiffActions }
                            </Table.Cell>
                        </Table.Row>
                    </Table.Head>
                    <Table.Body>
                        { dataDifferences &&
                            dataDifferences.map( ( record, index ) => {
                                return (
                                    <Table.Row key={`${ record.api.affiliate }-${ record.api.advertiserId }-${index}`}>
                                        <Table.Cell>{ record.api.affiliate }</Table.Cell>
                                        <Table.Cell>{ record.api.advertiserId }</Table.Cell>
                                        <Table.Cell>
                                            { record.db.advertiserName } (DATABASE)
                                            <br />
                                            { record.api.advertiserName } (API)
                                        </Table.Cell>
                                    </Table.Row>
                                );
                            } )
                        }
                    </Table.Body>
                </Table>
            </div>
        );
    }
}

export default connect()( FieldDiffsTable );
